/**
 * PlatformSwitch
 *
 * @selector [data-js-sitefooter]:not([data-variant="home"])
 * @enabled true
 */
import BaseModule from '../../modules/BaseModule.js';

export default class PlatformSwitch extends BaseModule {
    constructor() {
        super();
    }

    init(element) {
        this.el = element;
        this.$el = $(element);

        this.evaluateFooterVisibilty();
        this.on(document, 'scroll', this.onScroll);

        return this;
    }

    evaluateFooterVisibilty() {
        const isFooterInView = this.el.getBoundingClientRect().top <= window.innerHeight;

        if (isFooterInView) {
            document.documentElement.setAttribute('data-js-sitefooter-state', 'visible');
        } else {
            document.documentElement.removeAttribute('data-js-sitefooter-state', null);
        }
    }
    onScroll() {
        this.evaluateFooterVisibilty();
    }
}
